import React from 'react'
import { Avatar } from '@material-ui/core'

import helpers from 'helpers'
import styles from './styles'

const AvatarIcon = ({ company, clientPortalTheme }) => {
  const useStyles = styles(clientPortalTheme?.primaryColor)
  const classes = useStyles()
  const initials = helpers.avatarLetters(company?.name)

  return (
    <Avatar src={company?.logo} className={classes.avatar}>
      {initials?.[0]?.toUpperCase()}
    </Avatar>
  )
}

export default AvatarIcon
